<template>
    <div class="min-h-screen w-full bg-gray-50 flex justify-center items-center">
        <div class="w-96 bg-white shadow-md p-6 rounded-md">

            <form @submit.prevent="submitForm" v-if="!isNotMe && (!errors?.admission_id)">
                 <div v-if="!admission.student?.experience_letter">
                <p class="text-md font-bold">Hello , {{ admission.student.first_name }} {{
                        admission.student.middle_name
                    }}
                    {{ admission.student.last_name }} </p>
                <p class="mb-5">Course of {{ admission.course.title }}</p>

                <Label for="file-upload" value="Upload Experience Letter"/>
                <label
                    class="mt-3 flex justify-center px-6 pt-5 pb-6 border-2 border-gray-300 border-dashed rounded-md">
                    <div class="space-y-1 text-center">
                        <svg class="mx-auto h-12 w-12 text-gray-400" stroke="currentColor" fill="none"
                             viewBox="0 0 48 48"
                             aria-hidden="true">
                            <path
                                d="M28 8H12a4 4 0 00-4 4v20m32-12v8m0 0v8a4 4 0 01-4 4H12a4 4 0 01-4-4v-4m32-4l-3.172-3.172a4 4 0 00-5.656 0L28 28M8 32l9.172-9.172a4 4 0 015.656 0L28 28m0 0l4 4m4-24h8m-4-4v8m-12 4h.02"
                                stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                        </svg>
                        <div class="flex text-sm text-gray-600">
                            <label for="file-upload"
                                   class="relative cursor-pointer bg-white rounded-md font-medium text-indigo-600 hover:text-indigo-500 focus-within:outline-none focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-indigo-500">
                                <span>Upload a file</span>
                                <input @change="chooseFile" id="file-upload" type="file" class="sr-only" accept=".png, .jpg, .jpeg, .pdf">
                            </label>
                            <p class="pl-1">Click</p>
                        </div>
                        <p class="text-xs text-gray-500">
                            PNG, JPG, PDF up to 10MB
                        </p>
                    </div>
                </label>
                  <breeze-input-error class="mt-3" :message="uploadForm.errors.file"/>
                <p class="mt-3 font-md" v-if="uploadForm.file"> {{ uploadForm.file.name }}</p>

                <BreezeButton :disabled="false">Upload</BreezeButton>
                 </div>
                <div class="text-center" v-else>
                     <p class="text-md font-bold">Hello , {{ admission.student.first_name }} {{
                        admission.student.middle_name
                    }}
                    {{ admission.student.last_name }} </p>
                <p class="mb-5">Course of {{ admission.course.title }}</p>
                    <p class="font-bold">
                        You Already uploaded Experience Letter,
                        Thank You.
                    </p>
                </div>
            </form>
            <div v-else>
                <div class="col-span-4 sm:col-span-4">
                    <breeze-label :value="'Enter Admission ID'"/>
                    <breeze-input required v-model="form.admission_id" class="w-full my-3"/>
                    <breeze-input-error :message="errors.admission_id"/>
                </div>
                 <BreezeButton @click="redirectOther" type="button"  :disabled="false">Get Student</BreezeButton>

            </div>
            <hr class="my-4"/>
            <div>
                <p v-if="!isNotMe && (!errors?.admission_id)" class="mb-3 text-sm">Not {{ admission.student.first_name }}
                    {{ admission.student.middle_name }}
                    {{ admission.student.last_name }}? You can manually submit by clicking on Not Me Button. </p>

                <BreezeButton @click="isNotMe=!isNotMe;errors=[];" type="button" :disabled="false">
                    {{ (isNotMe && (!errors?.admission_id)) ? 'Go Back' : 'Not Me' }}
                </BreezeButton>
            </div>
        </div>

    </div>
</template>
<script setup>
import Label from "@/Components/Label";
import {ref, watch} from "vue";
import BreezeLabel from "@/Components/Label";
import BreezeButton from "@/Components/Button";
import BreezeInputError from "@/Components/InputError";
import BreezeInput from "@/Components/Input";
import {Inertia} from "@inertiajs/inertia";
import {useForm} from "@inertiajs/inertia-vue3";

const props= defineProps({
    admission: Object,
    errors: Object,
})

const isNotMe = ref(false);
const admission_id = ref('');
const form = useForm({
    admission_id:''
})
const uploadForm=useForm({
    file : []
})
function submitForm(){
   uploadForm.post(route('experience.letter.store',props.admission.id));
}
function redirectOther(){
    if(form.admission_id){
        form.get(route('experience.letter',form.admission_id));
    }
}

function chooseFile(e) {
    var data = e.target.files || e.dataTransfer.files;
    if (!data.length) return;
    uploadForm.file = data[0];
}
</script>
